module.exports = __webpack_public_path__ + "img/direction2.617d6d13.png";